document.addEventListener('DOMContentLoaded', function() {
  class AccountDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.initAccountIconListeners();
    }

    initAccountIconListeners() {
      // Trovare tutte le icone di account e assegnare l'event listener
      const accountIcons = document.querySelectorAll('[id*="AccountIconHeader"]');
      accountIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const accountDrawer = document.getElementById('AccountDrawer');
      setTimeout(() => { accountDrawer.classList.add('animate', 'active'); });

      accountDrawer.addEventListener('transitionend', () => {
        const focusElement = accountDrawer.querySelector('.drawer__inner') || accountDrawer.querySelector('.drawer__close');
        trapFocus(accountDrawer, focusElement);
      }, { once: true });

      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }

    close() {
      const accountDrawer = document.getElementById('AccountDrawer');
      accountDrawer.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
    checkIfDrawerShouldOpen() {
      console.log('Verifica se aprire il drawer');
      const urlParams = new URLSearchParams(window.location.search);
      console.log('Parametri URL:', urlParams.toString());
      if (urlParams.has('login') && urlParams.get('login') === 'open') {
        console.log('Apertura drawer');
        this.open();
      }else {
    console.log('Elemento account-drawer non trovato');
  }
    }
  }

  customElements.define('account-drawer', AccountDrawer);

  const accountDrawerElement = document.querySelector('account-drawer');
  if (accountDrawerElement) {
    accountDrawerElement.checkIfDrawerShouldOpen();
  } else {
    console.log('Elemento account-drawer non trovato');
  }
});